export class UserPermission {
    constructor({
        id = 0,
        application = '',
        email = '',
        permissionGroup = 0,
        company = '',

    } = {}) {
        this.id = id;
        this.application = application;
        this.email = email;
        this.company = company;
        this.permissionGroup = permissionGroup
        this.permissionGroupDescription = getPermissionDescription(permissionGroup);
    }
}

function getPermissionDescription(id) {
    switch (id) {
        case 1:
            return 'Admin';
        case 2:
            return 'Dealer';
        case 3:
            return 'DealerManagers';
        case 4:
            return 'Helpdesk';

        default:
            return '';
    }
}

export function CreateUserPermission(data) {
    return Object.freeze(new UserPermission(data))
}
